
import { Loader2 } from 'lucide-react';

const Loader = () => {
  return <Loader2 className="w-12 h-12 text-accent-green animate-spin" />;
}

export default Loader;